import React from "react";

export default function Complaints() {
    return (
        <main className="max-w-4xl mx-auto px-4 py-8">
            <h2 className="text-2xl font-bold mb-6">Complaints Procedure</h2>

            <p className="mb-4">
                Sometimes not everything goes to plan, it’s important to have your say.
                The following procedure explains how we deal with any complaints we
                receive and our commitments to you.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">
                How to contact us with your complaint
            </h3>
            <p className="mb-4">
                To help us investigate and resolve your issue as quickly as possible,
                please contact us via email or phone:
            </p>
            <ul className="list-disc ml-6 mb-4 text-slate-700">
                <li>
                    Telephone:{" "}
                    <a href="tel:01785716133" className="text-blue-600 underline">
                        01785 716133
                    </a>
                </li>
                <li>
                    Email:{" "}
                    <a
                        href="mailto:claytoncontracts@gmail.com"
                        className="text-blue-600 underline"
                    >
                        claytoncontracts@gmail.com
                    </a>
                </li>
            </ul>

            <h3 className="text-xl font-semibold mt-6 mb-3">
                What information should you include?
            </h3>
            <ul className="list-disc ml-6 mb-4 text-slate-700">
                <li>Your full name and preferred contact details</li>
                <li>Your order or vehicle registration number</li>
                <li>Full details of your complaint</li>
                <li>Copies of relevant paperwork</li>
                <li>
                    Photographic evidence of any vehicle damage/defects (where applicable)
                </li>
                <li>What you expect us to do to put things right</li>
                <li>Any other information you think may be relevant</li>
            </ul>
            <p className="mb-4">
                Please note: If you appoint a third party to act on your behalf we
                cannot discuss your contract with them until we receive your permission
                in writing or from your personal email address.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">
                What happens when we receive a complaint
            </h3>
            <p className="mb-4">
                We will always try to resolve your complaint immediately. However,
                sometimes this may not be possible. In all cases we will follow this
                process:
            </p>
            <ol className="list-decimal ml-6 mb-4 text-slate-700 space-y-2">
                <li>
                    <b>Written Acknowledgement:</b> within 3 working days (with case
                    number)
                </li>
                <li>
                    <b>Seek Clarification:</b> we may contact you if more details are
                    required
                </li>
                <li>
                    <b>Investigation:</b> full review of your complaint
                </li>
                <li>
                    <b>Progress Updates:</b> you will be kept informed
                </li>
                <li>
                    <b>Findings:</b> we will discuss our response with you
                </li>
                <li>
                    <b>Final Response:</b> within 10 working days, no later than 8 weeks
                </li>
            </ol>

            <h3 className="text-xl font-semibold mt-6 mb-3">Eligibility</h3>
            <p className="mb-4">
                It is Clayton Car Contracts policy to treat all complainants the same.
                However, certain types of complaints fall within the scope of FCA rules
                and the Financial Ombudsman Service (FOS).
            </p>
            <ul className="list-disc ml-6 mb-4 text-slate-700">
                <li>
                    Complaints made by, or on behalf of, an eligible complainant
                    (individuals and certain small businesses)
                </li>
                <li>Relating to provision or failure to provide a financial service</li>
                <li>Alleging financial loss, material distress, or inconvenience</li>
            </ul>

            <h3 className="text-xl font-semibold mt-6 mb-3">Closing a complaint</h3>
            <p className="mb-4">
                A complaint is considered closed when we have issued our final response.
                This does not prevent you from referring the matter to the Financial
                Ombudsman Service if you wish.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">
                What to do if you are not happy with our decision
            </h3>
            <p className="mb-4">
                If you are not satisfied with our Final Response, you may be eligible to
                refer the matter to the Financial Ombudsman Service (FOS). You must do
                this within six months of our final response.
            </p>

            <div className="bg-slate-50 border rounded p-4 text-sm">
                <p className="font-semibold">Financial Ombudsman Service</p>
                <p>Exchange Tower, London, E14 9SR</p>
                <p>
                    Tel: 0800 023 4567 (free), 0300 123 9123 (mobile), or 020 7964 0500
                    (from abroad)
                </p>
                <p>
                    Email:{" "}
                    <a
                        href="mailto:complaint.info@financial-ombudsman.org.uk"
                        className="text-blue-600 underline"
                    >
                        complaint.info@financial-ombudsman.org.uk
                    </a>
                </p>
                <p>
                    Website:{" "}
                    <a
                        href="https://www.financial-ombudsman.org.uk"
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue-600 underline"
                    >
                        www.financial-ombudsman.org.uk
                    </a>
                </p>
            </div>

            <p className="mt-6">
                If you have any questions about Clayton Car Contract’s complaints
                handling process, please call us on{" "}
                <a href="tel:01785716133" className="text-blue-600 underline">
                    01785 716133
                </a>{" "}
                or email{" "}
                <a
                    href="mailto:claytoncontracts@gmail.com"
                    className="text-blue-600 underline"
                >
                    claytoncontracts@gmail.com
                </a>
                .
            </p>
        </main>
    );
}
